/**
 * The groups of systems as chips: chosen = shown. Hiding one (and showing it again) is a history step, so Back
 * returns to the view before. Shown only when the registry has groups (Settings → Systems → a system's group).
 */
import { useSystems } from '../lib/systemsdata.tsx';
import { useSearchParams } from '../lib/liveparams.ts';
import { groupsOf, readHidden, withHidden } from '../lib/groups.ts';
import { cx } from '../design/primitives.tsx';
import { FacetChip } from './FilterChips.tsx';

export function GroupFilter({ className }: { className?: string }) {
  const { systems } = useSystems();
  const [params, setParams] = useSearchParams();
  const groups = groupsOf(systems.values());
  if (groups.length === 0) return null;
  const hidden = readHidden(params);
  const toggle = (name: string) => setParams((p) => withHidden(p, hidden.includes(name) ? hidden.filter((g) => g !== name) : [...hidden, name]));
  return (
    <div role="group" aria-label="Groups of systems shown" data-group-filter="" className={cx('flex items-center gap-1.5 flex-wrap', className)}>
      <span className="text-micro text-n7 uppercase tracking-wide font-semibold mr-1">Groups</span>
      {groups.map((g) => (
        <FacetChip key={g.name} chosen={!hidden.includes(g.name)} onClick={() => toggle(g.name)} data-key={g.name}
          title={`${hidden.includes(g.name) ? 'Show' : 'Hide'} ${g.name}: ${g.codes.join(', ')}`}>
          {g.name}
        </FacetChip>
      ))}
    </div>
  );
}
